var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBooks(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 507,
    height: 409,
    viewBox: "0 0 507 409",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M294.574 63.4727C262.071 62.1907 231.109 50.2884 201.549 37.2636C171.989 24.2388 142.71 9.80674 110.986 2.90691C90.5808 -1.53154 67.2431 -2.15828 50.8057 10.2512C34.981 22.2162 29.8685 42.8131 27.1214 61.9457C25.0523 76.338 23.837 91.4822 29.5069 104.957C33.4392 114.313 40.425 122.175 45.2513 131.166C62.0602 162.344 50.183 200.791 31.9678 231.234C23.4302 245.518 13.5115 259.152 6.92251 274.342C0.333508 289.532 -2.71993 306.961 3.04545 322.47C8.76563 337.853 22.3906 349.385 37.1456 357.505C67.1225 373.999 102.433 378.717 136.89 381.389C213.14 387.309 289.793 384.745 366.244 382.181C394.539 381.229 422.954 380.267 450.786 375.304C466.245 372.546 482.2 368.176 493.424 357.613C507.667 344.206 511.197 321.501 501.655 304.693C485.64 276.496 441.39 269.493 430.181 239.227C424.024 222.573 430.352 204.022 439.301 188.57C458.505 155.432 490.692 126.357 492.39 88.4796C493.555 62.4585 478.077 36.409 454.151 24.0964C429.076 11.1457 394.293 12.7866 375.801 34.147C356.748 56.1569 323.27 64.6008 294.574 63.4727Z",
    fill: "#82A3A7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M270.37 361.583L98.368 360.744L81.2773 320.658L141.71 316.271L131.178 272.32L250.707 256.828L136.248 217.038L146.359 214.636L330.406 244.662L320.271 313.251L305.783 350.945L270.37 361.583Z",
    fill: "#FFB1A3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M368.504 329.643C368.504 329.643 357.112 343.548 366.157 364.568L275.201 404.016L266.472 405.845L262.452 388.257L265.141 366.061V353.93L368.504 329.643Z",
    fill: "#D5D6DB"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M81.2773 320.659L207.169 297.708L373.98 324.282L270.37 361.584L81.2773 320.659Z",
    fill: "#FFB1A3"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M81.2773 320.659L207.169 297.708L373.98 324.282L270.37 361.584L81.2773 320.659Z",
    fill: "#D5E0E2"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M81.2774 320.653C81.2774 320.653 69.5033 342.96 83.0713 363.563L269.757 404.016C269.757 404.016 258.169 386.247 270.355 361.584L81.2774 320.653Z",
    fill: "#82A3A7"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M81.2774 320.653C81.2774 320.653 69.5033 342.96 83.0713 363.563L269.757 404.016C269.757 404.016 258.169 386.247 270.355 361.584L81.2774 320.653Z",
    fill: "black"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M86.8421 328.387C86.8421 328.387 80.1134 344.709 86.8421 355.272V328.387Z",
    fill: "black"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M269.759 404.016L373.982 359.543C373.982 359.543 379.811 360.799 376.042 365.07C372.273 369.342 271.769 408.287 271.769 408.287L83.0732 363.563L269.759 404.016Z",
    fill: "#D5E0E2"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M269.759 404.016L373.982 359.543C373.982 359.543 379.811 360.799 376.042 365.07C372.273 369.342 271.769 408.287 271.769 408.287L83.0732 363.563L269.759 404.016Z",
    fill: "black"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M261.215 366.075C261.215 366.075 251.164 378.136 261.215 396.227V366.075Z",
    fill: "black"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M309.874 365.872L264.793 380.912L264.952 381.388L310.033 366.348L309.874 365.872Z",
    fill: "black"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M318.903 364.375L264.778 384.957L264.957 385.426L319.081 364.845L318.903 364.375Z",
    fill: "black"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M327.195 364.303L265.08 389.728L265.27 390.193L327.385 364.768L327.195 364.303Z",
    fill: "black"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M336.214 362.126L265.807 393.931L266.014 394.389L336.421 362.584L336.214 362.126Z",
    fill: "black"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M343.79 362.136L266.364 395.978L266.566 396.439L343.991 362.596L343.79 362.136Z",
    fill: "black"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M360.359 359.322L267.53 399.416L267.73 399.877L360.558 359.784L360.359 359.322Z",
    fill: "black"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M128.05 323.111L216.493 304.518L270.373 314.819L197.9 338.186L128.05 323.111Z",
    fill: "white"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M373.981 324.281C373.981 324.281 378.554 326.126 375.87 328.975C373.187 331.824 270.356 361.583 270.356 361.583L373.981 324.281Z",
    fill: "#ABC2C5"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M418.399 281.311C418.399 281.311 407.012 295.211 416.057 316.236L325.101 355.684L316.373 357.523L312.353 339.935L315.081 317.744V305.598L418.399 281.311Z",
    fill: "#D5D6DB"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M131.181 272.321L257.067 249.375L423.883 275.949L320.274 313.251L131.181 272.321Z",
    fill: "#BEDAD7"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M131.16 272.321C131.16 272.321 119.381 294.628 132.949 315.231L319.635 355.684C319.635 355.684 308.052 337.9 320.253 313.246L131.16 272.321Z",
    fill: "#AED1CD"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M131.16 272.321C131.16 272.321 119.381 294.628 132.949 315.231L319.635 355.684C319.635 355.684 308.052 337.9 320.253 313.246L261.217 300.467L131.16 272.321Z",
    fill: "black"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M136.735 280.055C136.735 280.055 130.012 296.372 136.735 306.94V280.055Z",
    fill: "black"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M319.652 355.684L423.879 311.211C423.879 311.211 429.704 312.467 425.935 316.738C422.166 321.01 321.662 359.955 321.662 359.955L132.966 315.231L319.652 355.684Z",
    fill: "#CEE3E1"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M319.652 355.684L423.879 311.211C423.879 311.211 429.704 312.467 425.935 316.738C422.166 321.01 321.662 359.955 321.662 359.955L132.966 315.231L319.652 355.684Z",
    fill: "black"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M311.111 317.744C311.111 317.744 301.061 329.804 311.111 347.895V317.744Z",
    fill: "black"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M359.772 317.545L314.691 332.585L314.85 333.061L359.931 318.021L359.772 317.545Z",
    fill: "black"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M368.808 316.045L314.684 336.627L314.862 337.096L368.986 316.515L368.808 316.045Z",
    fill: "black"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M377.093 315.966L314.979 341.391L315.169 341.856L377.283 316.431L377.093 315.966Z",
    fill: "black"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M386.117 313.791L315.71 345.595L315.917 346.053L386.324 314.249L386.117 313.791Z",
    fill: "black"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M393.688 313.795L316.263 347.637L316.464 348.097L393.889 314.255L393.688 313.795Z",
    fill: "black"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M410.259 310.98L317.431 351.073L317.63 351.535L410.458 311.441L410.259 310.98Z",
    fill: "black"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.45,
    d: "M177.949 274.778L266.393 256.185L320.273 266.487L247.799 289.854L177.949 274.778Z",
    fill: "white"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M423.882 275.949C423.882 275.949 428.45 277.793 425.771 280.637C423.093 283.482 320.272 313.246 320.272 313.246L423.882 275.949Z",
    fill: "#AED1CD"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M423.124 226.018C423.124 226.018 411.732 250.978 420.778 271.999L329.822 300.391L321.113 302.235L317.093 284.647L319.781 262.451V250.305L423.124 226.018Z",
    fill: "#D5D6DB"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M135.918 217.033L261.809 194.083L428.626 220.656L325.011 257.959L135.918 217.033Z",
    fill: "#FFC4BA"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M135.919 217.028C135.919 217.028 124.125 239.335 137.693 259.938L324.379 300.391C324.379 300.391 312.791 282.607 324.992 257.959L135.919 217.028Z",
    fill: "#FFB1A3"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M135.919 217.028C135.919 217.028 124.125 239.335 137.693 259.938L324.379 300.391C324.379 300.391 312.791 282.607 324.992 257.959L135.919 217.028Z",
    fill: "black"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M141.482 224.762C141.482 224.762 134.753 241.084 141.482 251.647V224.762Z",
    fill: "black"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M324.399 300.391L428.621 266.973C428.621 266.973 434.451 268.23 430.682 272.501C426.913 276.772 326.409 304.662 326.409 304.662L137.713 259.938L324.399 300.391Z",
    fill: "#FFB1A3"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M324.399 300.391L428.621 266.973C428.621 266.973 434.451 268.23 430.682 272.501C426.913 276.772 326.409 304.662 326.409 304.662L137.713 259.938L324.399 300.391Z",
    fill: "black"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M315.856 262.451C315.856 262.451 305.806 274.511 315.856 292.602V262.451Z",
    fill: "black"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M364.519 262.252L319.438 277.292L319.598 277.768L364.678 262.728L364.519 262.252Z",
    fill: "black"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M373.551 260.755L319.427 281.336L319.605 281.806L373.73 261.225L373.551 260.755Z",
    fill: "black"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M381.831 260.678L319.717 286.103L319.907 286.568L382.022 261.143L381.831 260.678Z",
    fill: "black"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M390.861 258.498L320.454 290.303L320.661 290.761L391.068 258.956L390.861 258.498Z",
    fill: "black"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M398.43 258.507L321.005 292.349L321.206 292.81L398.632 258.967L398.43 258.507Z",
    fill: "black"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M415.003 255.695L322.175 295.789L322.374 296.25L415.203 256.157L415.003 255.695Z",
    fill: "black"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M182.687 219.486L271.13 200.893L325.01 211.194L252.537 234.561L182.687 219.486Z",
    fill: "white"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M428.621 220.657C428.621 220.657 433.194 222.501 430.511 225.35C427.827 228.2 325.012 257.959 325.012 257.959L428.621 220.657Z",
    fill: "#FFB1A3"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M289.416 261.527C289.416 261.527 293.778 251.687 305.426 259.19",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M333.936 225.004C335.749 223.642 337.68 222.443 339.704 221.421C342.72 219.969 348.247 216.2 348.247 216.2",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBooks);
export default __webpack_public_path__ + "static/media/books.9a5a89b3.svg";
export { ForwardRef as ReactComponent };